import React, { PropsWithChildren } from 'react';
import { Flex } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';

import * as S from './page.style';
import { BackButton } from './page.style';

interface Props extends PropsWithChildren {
    readonly title: string;
    readonly isBackButton?: boolean;
    readonly backRoute?: string;
}

export const Page = ({ title, children, isBackButton, backRoute }: Props) => {
    const navigate = useNavigate();

    return (
        <main>
            <Flex align={'center'} gap={16}>
                {isBackButton && (
                    <BackButton
                        onClick={() => navigate(backRoute ? backRoute : -1)}
                        shape='circle'
                        icon={<LeftOutlined />}
                    ></BackButton>
                )}
                <S.Head>{title}</S.Head>
            </Flex>
            {children && <S.Content>{children}</S.Content>}
        </main>
    );
};
